module.exports = __webpack_public_path__ + "img/kmtc_flag_s_logo.75ab20d8.png";